/*
 * @Author: Jordan
 * @Date: 2019-07-24 19:01:46
 * @Last Modified by: Jordan
 * @Last Modified time: 2021-05-18 09:02:24
 */
import { login, loginOut } from '@/api/interface/interface-list/user'
import { getParentMenuFront } from '@/api/interface/interface-list/common'
const app = {
  state: {
    menuIndex: -1,
    loadingFlag: false,
    userInfo: null,
    teamUser: null,
    projectName: '',
    setting: {
      sysName: '',
      lcCode: ''
    },
    timeDiff: 0,
    behavior: {
      isPraise: true, // 点赞
      isScore: true, // 评分
      isSign: true,
      canCollect: true
    },
    count: {
      praiseCount: 0,
      scoreCount: 0,
      readCount: 0,
      shareCount: 0
    },
    cityName: null, // 所在城市
    longitude: null, // 用户所在纬度
    latitude: null, // 用户所在经度
    loginFlag: false,
    registerFlag: false,
    share: { // pc分享信息
      title: '分享的标题',
      url: window.location.href,
      cover: ''
    },
    hideFlag: false,
    hideBottomFlag: false,
    preUrl: {},
    nowUrl: {},
    breadObj: {},
    thirdUser: null,
    comment_flg: 0,
    mapFlag: false,
    vrUrL: '',
    uploadcount: 0
  },

  mutations: {
    SET_MENUINDEX: (state, menuIndex) => {
      state.menuIndex = menuIndex
    },
    SET_VR: (state, vrUrL) => {
      state.vrUrL = vrUrL
    },
    SET_MAPFLAG: (state, mapFlag) => {
      state.mapFlag = mapFlag
    },
    SET_TEAM: (state, teamUser) => {
      state.teamUser = teamUser
    },
    SET_HIDEBOTTOM: (state, hideBottomFlag) => {
      state.hideBottomFlag = hideBottomFlag
    },
    SET_THIRDUSER: (state, thirdUser) => {
      state.thirdUser = thirdUser
    },
    SET_COMMONT_FLG: (state, comment_flg) => {
      state.comment_flg = comment_flg
    },
    SET_BREAIDOBJ: (state, obj) => {
      state.breadObj = obj
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_REGISTERSTATE: (state, registerFlag) => {
      state.registerFlag = registerFlag
    },
    SET_SYSTIME: (state, timeDiff) => {
      state.timeDiff = timeDiff
    },
    SET_USERINFO: (state, userinfo) => {
      state.userInfo = userinfo
    },
    SET_LOGINSTATE: (state, loginFlag) => {
      state.loginFlag = loginFlag
    },
    SET_PROJECTNAME: (state, projectName) => {
      state.projectName = projectName
    },
    SET_CITY: (state, cityName) => {
      state.cityName = cityName
    },
    SET_LONGITUDE: (state, longitude) => {
      state.longitude = longitude
    },
    SET_LATITUDE: (state, latitude) => {
      state.latitude = latitude
    },
    CONTROL_LOADDING: (state, loadingFlag) => {
      state.loadingFlag = loadingFlag
    },
    SET_MAPDATA: (state, obj) => {
      state.cityName = obj.city
      state.longitude = obj.bounds.northeast.lng
      state.latitude = obj.bounds.northeast.lat
      state.latitude = obj.bounds.northeast.lat
    },
    SET_BEHAVIOR: (state, obj) => {
      state.behavior.isPraise = obj.canPraise
      state.behavior.isScore = obj.canScore
      state.behavior.isSign = obj.canJoin
      state.behavior.groupCanJoin = obj.groupCanJoin
      state.behavior.canCollect = obj.canCollection
    },
    SET_PRAISE: (state, isPraise) => {
      state.behavior.isPraise = isPraise
    },
    SET_COLLECT: (state, canCollect) => {
      state.behavior.canCollect = canCollect
    },
    SET_SCORE: (state, isScore) => {
      state.behavior.canScore = isScore
    },
    SET_COUNT: (state, obj) => {
      state.count.praiseCount = obj.praiseCount
      state.count.scoreCount = obj.scoreCount
      state.count.shareCount = obj.shareCount
      state.count.readCount = obj.readCount
    },
    SET_SHARE: (state, obj) => {
      state.share.title = obj.title
      state.share.url = obj.url
      state.share.cover = obj.cover
    },
    SET_SHARECOUNT: (state) => {
      state.count.shareCount++
    },
    SET_READCOUNT: (state) => {
      state.count.readCount++
    },
    SET_HIDEFLAG: (state, hideFlag) => {
      state.hideFlag = hideFlag
    },
    // 设置前一个路由
    SET_LASTURL: (state, obj) => {
      state.preUrl = obj
    },
    SET_NOWURL: (state, obj) => {
      state.nowUrl = obj
    },
    SET_UPLOADCOUNT: (state, uploadcount) => {
      state.uploadcount = uploadcount
    }
  },
  actions: {
    // 用户登录
    login({ commit }, userInfo) {
      const { mobile, pwd, verifyCodes } = userInfo
      return new Promise((resolve, reject) => {
        login({ mobile: mobile.trim(), pwd: pwd, verifyCodes: verifyCodes }).then(response => {
          const { data } = response
          if (data.status.returnCode === 100) {
            commit('SET_USERINFO', response.data.data.list[0].user)
          }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 用户登出
    loginOut({ commit }) {
      return new Promise((resolve, reject) => {
        loginOut().then(res => {
          commit('SET_USERINFO', null)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取菜单单独的id
    getMenuId({ commit }, breadId) {
      return new Promise((resolve, reject) => {
        getParentMenuFront({ id: breadId }).then(res => {
          const { data } = res
          if (data.status.returnCode === 100) {
            // commit('SET_BREAID', res.data.data.list[0].id)
          }
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js